import React from 'react';
import { Outlet } from 'react-router-dom';
import SideMenu from './SideMenu';
import { useAuth } from '../context/AuthContext';

export type MainLayoutOutletContext = {
    authUser: ReturnType<typeof useAuth>['user']
}

const MainLayout: React.FC = () => {
    const { status, user } = useAuth()

    if (status === 'loading') {
        return <div className="p-4">Loading...</div>
    }

    return (
        <div className="flex bg-gray-100">
            <SideMenu role={user?.role ?? null} />
            <main className="flex-1 overflow-auto h-screen">
                <Outlet context={{ authUser: user }} />
            </main>
        </div>
    );
};

export default MainLayout;
